import React from 'react';
import Form from 'react-bootstrap/Form';

interface CourseFilterCheckboxProps {
    checkboxName: string;
    checkboxValue: string | number;
    checked: boolean;
    className?: string;
    courseCount?: number;
    handleFilterChange: React.ChangeEventHandler<HTMLInputElement>;
    idPrefix?: string;
    indeterminate?: boolean;
    label: string;
}

const CourseFilterCheckbox: React.FC<CourseFilterCheckboxProps> = ({
    checkboxName,
    checkboxValue,
    checked,
    className,
    courseCount,
    handleFilterChange,
    idPrefix = '',
    indeterminate,
    label,
}) => {
    return (
        <Form.Check className={className} custom id={idPrefix + checkboxValue}>
            <Form.Check.Input
                checked={checked}
                form="search-courses-form"
                name={checkboxName}
                onChange={handleFilterChange}
                ref={(checkbox: HTMLInputElement) => {
                    if (checkbox) {
                        checkbox.indeterminate = !!indeterminate;
                    }
                }}
                type="checkbox"
                value={checkboxValue}
            />
            <Form.Check.Label className="pl-2 w-100">
                {label + (courseCount ? ` (${courseCount})` : '')}
            </Form.Check.Label>
        </Form.Check>
    );
};

export { CourseFilterCheckbox, CourseFilterCheckboxProps };
